import React from 'react'
import { ContentHeader } from '../../layout/Content'

function StockOutHeader() {
  return ( <ContentHeader title='Stock Out'/> )
}

export default React.memo(StockOutHeader)
